import { URLs } from "./apis";

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const verifyHashWorker = async (
  hash,
  supportedHashAlgoMap,
  created = false,
  setIsLoading,
  setError,
  setStampData,
  setCurrentScreen,
  setButton,
  setLoading,
) => {
  try {
    setIsLoading(true);
    supportedHashAlgoMap = supportedHashAlgoMap || {};

    // Add hash if missing
    if (!(hash in supportedHashAlgoMap)) {
      supportedHashAlgoMap[hash] = hash;
    }

    // Prepare request
    const objectHashes = Object.keys(supportedHashAlgoMap || {});
    const requestData = {
      cids: objectHashes,
      "filter-by-user": true,
    };
    const csrfToken = document.querySelector(
      "[name=csrfmiddlewaretoken]",
    ).value;

    const fetchData = async () => {
      const response = await fetch(URLs.VERUFY_API_URL, {
        method: "POST",
        headers: { "X-CSRFToken": csrfToken },
        body: JSON.stringify(requestData),
      });
      return response.json();
    };

    // Wait 1 seconds before first attempt
    if (created) {
      await wait(1000);
    }
    let data = await fetchData();

    // Retry once after 3 seconds if no results
    if (!data.stamp_list || data.stamp_list.length === 0) {
      if (created) {
        await wait(3000);
        data = await fetchData();
      }
    }

    // Handle response
    if (data.stamp_list && data.stamp_list.length > 0) {
      setError(null);
      const lastElement = {
        ...data.stamp_list[data.stamp_list.length - 1],
        display_timezone: data.display_timezone,
      };
      setStampData(lastElement);

      if (created) {
        setCurrentScreen("created");
      } else {
        const userStampsFound = data.stamp_list.length > 0;
        if (userStampsFound) {
          setCurrentScreen("found");
        }
        setButton(true);
      }
    } else {
      setButton(true);
      setCurrentScreen("");
      if (data.message === "Invalid Content ID.") {
        setButton(true);
      }
    }
  } catch (error) {
    console.error("Error in API request:", error);
    setError("An error occurred while verifying the stamp.");
    setLoading(false);
    setButton(true);
  } finally {
    setIsLoading(false);
  }
};
